export enum InputFieldName {
    CardNumber= 'CardNumber',
    CardHolderName = 'CardHolderName',
    ExpiryDate = 'ExpiryDate',
    Cvv = 'Cvv'
}
